var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2903_389324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0006 4.5V3.9C6.0006 2.5725 6.0006 1.5 8.4006 1.5H9.6006C12.0006 1.5 12.0006 2.5725 12.0006 3.9V4.5M6.0006 16.5H12.0006C15.0156 16.5 15.5556 15.2925 15.7131 13.8225L16.2756 7.8225C16.4781 5.9925 15.9531 4.5 12.7506 4.5H5.2506C2.0481 4.5 1.5231 5.9925 1.7256 7.8225L2.2881 13.8225C2.4456 15.2925 2.9856 16.5 6.0006 16.5Z",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2383 8.25C14.5479 9.47765 12.574 10.2569 10.5008 10.515M1.96582 8.4525C3.65332 9.6075 5.55832 10.305 7.50082 10.5225M10.5008 9.75V10.515C10.5008 11.3325 10.4933 12 9.00082 12C7.51582 12 7.50082 11.34 7.50082 10.5225V9.75C7.50082 9 7.50082 9 8.25082 9H9.75082C10.5008 9 10.5008 9 10.5008 9.75Z",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2903_389324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.0800db7ed8c6d6089a11f7cbec069611.svg";
export { ForwardRef as ReactComponent };